import React from 'react';

const FormField = ({ label, id, type = 'text', children, ...props }) => (
    <div>
        {label && <label htmlFor={id} className="block text-sm font-medium text-gray-300 mb-1">{label}</label>}
        {type === 'select' ? (
             <select id={id} {...props} className="w-full px-3 py-2 bg-gray-800 border border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-brand-gold focus:border-brand-gold text-white">
                 {children}
             </select>
        ) : type === 'textarea' ? (
            <textarea id={id} {...props} className="w-full px-3 py-2 bg-gray-800 border border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-brand-gold focus:border-brand-gold text-white" />
        ) : (
            <input id={id} type={type} {...props} className="w-full px-3 py-2 bg-gray-800 border border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-brand-gold focus:border-brand-gold text-white" />
        )}
    </div>
);

export default FormField;